export default function removeSpace(string) {
    const str = string.replace(/\s+/g, "");
    return str;
}
